import { render, staticRenderFns } from "./GeneralItem.vue?vue&type=template&id=8ed9aa9e&scoped=true&"
import script from "./GeneralItem.vue?vue&type=script&lang=js&"
export * from "./GeneralItem.vue?vue&type=script&lang=js&"
import style0 from "./GeneralItem.vue?vue&type=style&index=0&id=8ed9aa9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed9aa9e",
  null
  
)

export default component.exports